export default __webpack_public_path__ + "491e51c0f9a39db0fe8eed50aa37d8b0.svg";